module.exports = require('./helpers/bundle-url').getBundleURL('4ZtNJ') + "error-illustration.5855be79.svg";